import { injectable } from 'tsyringe';
import { Utils } from '../../../shared/utils/utils';
import { Promotion } from '../../models/promotion.model';

// -----------------------------------------------------------------------------
// Randomly (weighted) select an application from the a given list and then
// keep state so the next selection won't include a previously selected app
@injectable()
export class WeightedRandomAppSelector {
  private applications: Promotion[] = [];

  // ---------------------------------------------------------------------------
  public initialize(applications: Promotion[]) {
    this.applications = Utils.deepClone(applications);
  }

  // ---------------------------------------------------------------------------
  public next(): Promotion | null {
    if (this.applications?.length === 0) {
      return null;
    }

    const shuffledArray = this.fillArrayWithAppIndices();
    this.fisherYatesShuffle(shuffledArray);

    const randomIndex = Utils.randomWholeNumber(0, shuffledArray.length - 1);
    const randomAppIndex = shuffledArray[randomIndex];
    const randomApp = this.applications[randomAppIndex];

    this.applications.splice(randomAppIndex, 1);
    return randomApp;
  }

  // ---------------------------------------------------------------------------
  private fillArrayWithAppIndices() {
    const appIndicesArray: number[] = [];

    for (let appIndex = 0; appIndex < this.applications.length; ++appIndex) {
      const app = this.applications[appIndex];

      for (let counter = 0; counter < app.recommendWeight; ++counter) {
        appIndicesArray.push(appIndex);
      }
    }

    return appIndicesArray;
  }

  // ---------------------------------------------------------------------------
  private fisherYatesShuffle(shuffledArray: number[]) {
    for (let i = shuffledArray.length - 1; i >= 0; --i) {
      const j = Utils.randomWholeNumber(0, i);
      const temp = shuffledArray[i];
      shuffledArray[i] = shuffledArray[j];
      shuffledArray[j] = temp;
    }
  }
}
